/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
'use strict';

/**
 * Filter module related to moment formatting.
 */
angular
  .module('filters.moment', [])
  /**
   * Filter that will format a date using a key from the resource file.
   *
   * @params {Date|String|Number} dateItem - A value to be parsed by moment.
   * @params {String} dateFormat - A key that will be used to lookup a value from the resource file.
   * @returns {String} - The formatted date string.
   */
  .filter('momentFilter', [
    '$filter',
    function ($filter) {
      return function (dateItem, dateFormat) {
        if (!dateItem || !dateFormat) {
          return '';
        }
        return moment(dateItem).format($filter('i18n')(dateFormat));
      };
    }
  ])
  /**
   * Converts a duration in seconds into a human readable string.  If the value provided is less then
   * 60 seconds or is invalid it will default to the value 1 m.
   */
  .filter('durationFilter', [
    '$filter',
    function ($filter) {
      /**
       * Filter function use to convert duration to string.
       *
       * @param {Number} [duration=60] - Number of seconds.
       * @returns {String} - The duration in Minutes (m), Hours (h), or Days (d).  It takes the format
       *  # (m|d|h).
       */
      return function (duration) {
        duration = duration || 60;
        duration = duration < 60 ? 60 : duration;
        if (duration < 60 * 60) {
          return $filter('i18n')('SHORT_MINUTES', moment.duration(duration, 'seconds').minutes());
        } else if (duration < 60 * 60 * 24) {
          return $filter('i18n')('SHORT_HOURS', moment.duration(duration, 'seconds').hours());
        } else {
          return $filter('i18n')('SHORT_DAYS', moment.duration(duration, 'seconds').days());
        }
      };
    }
  ])
  /**
   * Provides a short humanized version of a date.
   */
  .filter('shortHumanizeFilter', [
    '$filter',
    function ($filter) {
      /**
       * Filter function use to convert date to a humanized string for use in mobile.
       *
       * @param {date} - The date to humanize
       * @returns {String} - A string representing the date.  If today it will return the time.
       * For yesterday it will return Yest. For any date within a week but not covered by the first
       * two conditions it will return a short day name.  For any other date it will return a short
       * date.
       */
      return function (dateTime) {
        var momentDate = moment(dateTime),
          now = moment(),
          yesterday = moment().subtract(1, 'day').startOf('day'),
          week = moment().subtract(1, 'week').endOf('day');
        if (!momentDate.isBefore(now.startOf('day'))) {
          return momentDate.format($filter('i18n')('TIME'));
        } else if (!momentDate.isBefore(yesterday)) {
          return $filter('i18n')('YESTERDAY_SHORT');
        } else if (!momentDate.isBefore(week)) {
          return momentDate.format($filter('i18n')('DAY'));
        } else {
          return momentDate.format($filter('i18n')('M_D'));
        }
      };
    }
  ]);
